var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.175 20.475q-1.125 0-1.887-.763-.763-.762-.763-1.887V5.95q0-1.1.763-1.875Q3.05 3.3 4.175 3.3H9.8L12 5.525h7.825q1.125 0 1.888.762.762.763.762 1.888v9.65q0 1.125-.762 1.887-.763.763-1.888.763ZM16 17.825h3.825v-9.65H16v1.95h1.925v1.9H16v1.925h1.925v1.95H16Zm-11.825 0h9.9v-1.95H16V13.95h-1.925v-1.925H16v-1.9h-1.925v-1.95H10.9L8.7 5.95H4.175v11.875Zm0-9.65V5.95v11.875-9.65Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip);
export default __webpack_public_path__ + "static/media/icon_zip.b9ae19b1a03a7cfcc89dd5c6c14f12e3.svg";
export { ForwardRef as ReactComponent };